import { render, staticRenderFns } from "./DispensacionSavia.vue?vue&type=template&id=51267554&scoped=true"
import script from "./DispensacionSavia.vue?vue&type=script&lang=js"
export * from "./DispensacionSavia.vue?vue&type=script&lang=js"
import style0 from "./DispensacionSavia.vue?vue&type=style&index=0&id=51267554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51267554",
  null
  
)

export default component.exports